<template>
  <DefaultLayout>
    <template #buttons>
    </template>

    <UserFilter :filters="filters">
      <h1 class="h5 mt-2">
        {{ i18n('Users') }}
        <span class="small text-muted" v-if="!pagination?.total">({{ users.length }})</span>
        <span class="small text-muted" v-else>({{ pagination?.total }})</span>
      </h1>
      <template #buttons>
        <UserCreateAction cssClass="ms-1" @created="reload" v-if="can('USER_MANAGE') || can('RESPONSIBLE_USER_MANAGE')" @export="exportUsers" />
      </template>
    </UserFilter>

    <UserList :pagination="pagination" :users="users" :loading="loading"
      :autoLazyLoad="!pagination.singlePage && !!pagination.nextPageURI" @deleted="reload" @updating="loading = true"
      @updated="reload" @next="nextPage" @goToPage="goToPage" @orderBy="orderBy" />
  </DefaultLayout>
</template>

<script>
import paginatedViewMixin from "@/mixins/common/paginatedViewMixin.js";
import api from "@/api.js";
import { canAccessPage } from "@/routeAcl.js";
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import UserCreateAction from "@/components/user/UserCreateAction.vue";
import UserFilter from "@/components/user/UserFilter.vue";
import UserList from "@/components/user/UserList.vue";
import { duplicate } from "@/tools/object.js";

export default {
  mixins: [paginatedViewMixin,],
  components: {
    DefaultLayout,
    UserCreateAction,
    UserFilter,
    UserList,
  },
  data() {
    return {
      listPropertyName: 'users',
      apiResource: `users`,
      users: [],
      filters: {
        is_deleted: 0,
      },
    }
  },
  mounted() {
    this.$root.setPageTitle(this.i18n('Users'));
    api.auth().then((user) => {
      this.$root.loggedUser = user;

      if (!user.loggedIn) {
        return; // Layout non-anonymous will handler redirect
      }

      if (!canAccessPage(this.$route?.name, user, this.$root.features)) {
        this.$router.push({ name: 'Index', });
        return;
      }

      this.load();
    });
  },
  watch: {
    params: {
      handler() {
        this.pagination.loadPages = 1;
        this.reload();
      },
      deep: true,
    },
  },
  methods: {
    extendApiParams(params) {
      params.acl = 'user';

      if (!params.company) {
        delete params.office;
        delete params.department;
      }
    },
    orderBy(column) {
      this.filters.orderBy = column;
    },
    usersCount() {
      if (!this.showList) {
        return 0;
      }

      if (!this.pagination?.total) {
        return this.users.length;
      }

      return this.pagination?.total;
    },
    exportUsers() {
      let exportParams = duplicate(this.params);
      exportParams.export = 1;
      delete exportParams.limit;

      api.getFile(`users`, exportParams, 'Users.xlsx');
    }
  },
  created() {
    this.pagination.singlePage = true;
    this.pagination.disabled = false;
  },
};
</script>